<p *ngIf="loaded$ | async" [innerHTML]="(htmlContentInput$ | async) | safeHtml"></p>
<div class="terms-of-services-spinner">
    <mat-progress-spinner *ngIf="!(loaded$ | async)" color="primary" mode="indeterminate" diameter="60">
    </mat-progress-spinner>
</div>
